<div class="space-y-4">
  @if (error()) {
    <app-inline-notice tone="error" [message]="error()" />
  }

  <app-tabs label="Kampagnen nach Status" [items]="statusTabs()" [value]="activeStatusFilter()" (valueChange)="setFilter($any($event))" />

  @if (!isLoading() && campaigns().length === 0) {
    <app-state-panel
      title="Noch keine Kampagnen"
      description="Eine Kampagne rechnet für eine Adressliste jedes Dach durch und erzeugt die Berichte für die Eigentümer."
    >
      @if (canCreate()) {
        <button hlmBtn (click)="openCreateDialog()">
          <ng-icon name="lucidePlus" class="size-4" />
          Erste Kampagne anlegen
        </button>
      }
    </app-state-panel>
  } @else {
    <app-data-table
      [data]="filteredCampaigns()"
      [columns]="columns()"
      [isLoading]="isLoading()"
      [rowActions]="rowActions()"
      [searchableFields]="['title', 'region']"
      [showLimitFilter]="false"
      [showAddButton]="canCreate()"
      addNewLabel="Neue Kampagne"
      searchPlaceholder="Kampagne suchen"
      emptyStateTitle="Keine Kampagnen mit diesem Status"
      emptyStateDescription="Wählen Sie oben einen anderen Status."
      (addNew)="openCreateDialog()"
      (rowClick)="openCampaign($event)"
    />
  }

  <ng-template #nameTpl let-campaign>
    <div class="min-w-48">
      <div class="truncate text-sm text-foreground">{{ campaign.title }}</div>
      @if (campaign.region) {
        <div class="truncate text-xs text-muted-foreground">{{ campaign.region }}</div>
      }
    </div>
  </ng-template>

  <ng-template #statusTpl let-campaign>
    <app-campaign-status-badge [status]="campaign.status" />
  </ng-template>

  <ng-template #progressTpl let-campaign>
    @if (campaign.status === processing) {
      <div class="flex items-center gap-2">
        <div class="h-1 w-24 overflow-hidden rounded-full bg-muted" aria-hidden="true">
          <div class="h-full rounded-full bg-primary transition-[width] duration-500 ease-out" [style.width.%]="progressPercent(campaign)"></div>
        </div>
        <span class="font-mono text-2xs tabular-nums text-muted-foreground">{{ progressPercent(campaign) }} %</span>
      </div>
    } @else {
      <span class="text-dense text-muted-foreground">{{ progressText(campaign) }}</span>
    }
  </ng-template>

  <ng-template #countTpl let-campaign>
    <div class="text-right text-sm tabular-nums">{{ campaign.analysisCount ?? 0 | number }}</div>
  </ng-template>

  <ng-template #dateTpl let-campaign>
    <span class="whitespace-nowrap font-mono text-xs text-muted-foreground">{{ campaign.createdAt | date: "dd.MM.yyyy" }}</span>
  </ng-template>

  <app-create-campaign-dialog
    #createDialog
    [organizationId]="orgId()"
    (submitted)="onCampaignCreated($event)"
    (cancelled)="onCreateCancelled()"
  />
</div>
